import React from "react";
import styles from "./Filter.module.css";

function RegionFilter({ onRegionChange }) {
  const handleRegionChange = (event) => {
    const value = event.target.value;
    onRegionChange(value === "View All" ? "" : value); // "View All"이면 빈 문자열로 전달
  };

  return (
    <select onChange={handleRegionChange} className={styles.filter}>
      <option value="View All">Location: View All</option>
      <option value="Manhattan">Manhattan</option>
      <option value="Brooklyn">Brooklyn</option>
      <option value="Queens">Queens</option>
      <option value="New Jersey">New Jersey</option>
    </select>
  );
}

export default RegionFilter;
